import { gqlClient } from "@root/apollo/apollo-options";
import { toMapByValue } from "@root/store/root";
import gql from "graphql-tag";

let isArray = arraylike => arraylike instanceof Array;

// 与store高耦合
export class QueryDataDictionary {
  constructor({ i18n, store }) {
    this.i18n = i18n;
    this.store = store;
  }

  _commit(name, value) {
    return this.store.commit("root/UPDATE_DDCODE", {
      name,
      value
    });
  }

  // _filter(codes = []) {
  //   console.log(this.store)
  //   let ddState = this.store.state.root.ddCodes;
  //   // 排除掉store中已经存在的字典 避免一次不需要的请求
  //   return codes.filter(code => !ddState[code] || !ddState[code].length);
  // }

  async _query(codes, { lang }) {
    let res = null;

    if (codes.length) {
      try {
        res = await gqlClient.query({
          query: queryJoin(codes, lang)
        });
      } catch (err) {
        console.error(err);
      } finally {
        const { data = {} } = res || {};
        codes.map(d => {
          // ！！！即便是数据请求出错 也需要将该数据字典commit一个空数组
          const listResult = data[d] || [];
          this._commit(d, listResult);
          // ！！！同时也会commit一个带有 '_MAP' 为后缀的state， 该state为数据字典返回的 数组 转换的 MAP
          this._commit(`${d}_MAP`, toMapByValue(listResult));
        });
      }
    }

    return res ? res.data : {};
  }

  preSet(codes) {
    codes.forEach(code => {
      this._commit(code, []);
      this._commit(`${code}_MAP`, {});
    });
  }

  register(codes, config = {}) {
    let ddCodes = isArray(codes) ? codes : [codes];
    // let ddCodes = this._filter(isArray(codes) ? codes : [codes]);

    // per set 值的预设
    this.preSet(ddCodes);

    return {
      query: this.query.bind(this, ddCodes, { ...config, filter: false }),
      codes,
      config
    };
  }

  // 低鲁棒性 -> codes需要类型检查
  query(codes, { lang, filter = true } = {}) {
    codes = isArray(codes) ? codes : [codes];

    return this._query(filter ? this._filter(codes) : codes, {
      lang: lang || this.i18n.locale
    });
  }

  // clear 目前有未知的bug 不建议使用
  clear() {
    this.store.commit("root/CLEAR_DDCOED");
  }
}

export function queryJoin(list, lang) {
  const queries = list
    .map(ddCode => {
      return `
      ${ddCode}: queryDataDictionaryListLang(input: { ddCode: "${ddCode}", lang: "${lang}" } ) {
        value: ddValue
        label: ddText
        ddRemark
      }`;
    })
    .join(",");

  return gql`query queryDataDictionaryListLang {${queries}}`;
}

export default {
  install(Vue, config = {}) {
    Vue.prototype.$dd = new QueryDataDictionary(config);
  }
};
